module.exports = __webpack_public_path__ + "img/listaUnidad.254f125e.jpg";